module.exports = __webpack_public_path__ + "img/_04_9f42c8d17.png";